<template>
    <div class="main-content">
        <div class="h5-content">
            <iframe :src="web_url" style="width: 100%;height: 100%;"></iframe>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            web_url: ''
        }
    },
    methods: {
        checkIsMobile() {
            const userAgentInfo = navigator.userAgent;
            const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
            for (let i = 0; i < mobileAgents.length; i++) {
                if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
                    return true;
                }
            }
            return false;
        },
    },
    created() {
        if(this.checkIsMobile()) {
            this.$router.push('/home');
        }
        this.web_url = window.location.href.split('#')[0] + '#/home?IamPc=1'
    }
}
</script>

<style>
.main-content {
    width: 100%;
    height: 100%;
    background-color: #222;

}

.h5-content {
    width: 400px;
    height: 100%;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    background-color: #f5f5f5;
}

.h5-content::-webkit-scrollbar {
    width: 0;
}
</style>